import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize } from 'react-localize-redux';
import { popupActions } from '../../../../store/popupStore';
import { domainActions } from '../../../../store/domainStore';
import { unicornFinStatementTypes, unicornFinValuesIfrsConsolidated, unicornFinValuesIfrsIndividual, unicornFinValuesIfrsOriginal, unicornFinStatementOrganizationValues } from "../../../../store/marketingListStore";
import { getNested, isFunction } from '../../../../store/storeFunctions';
import UpravitIcon from "../../../../img/icons/Upravit";

import '../../../common/popupMultiSelectButton.css';

const FIN_STATEMENT_ROWS = 'fin-statement-values';

class FinStatementsMultiSelectPopupButton extends React.Component {
    state = {
        initialized: false
    }

    componentDidMount() {
        var types = null;
        switch (this.props.finTypesDomain) {
            case "fin-statement-types": types = unicornFinStatementTypes(); break;
            case "fin-statement-types-ifrs-consolidated": types = unicornFinValuesIfrsConsolidated(); break;
            case "fin-statement-types-ifrs-individual": types = unicornFinValuesIfrsIndividual(); break;
            case "fin-statement-types-ifrs-orig": types = unicornFinValuesIfrsOriginal(); break;
            case "fin-statement-values-organizations-types": types = unicornFinStatementOrganizationValues(); break;

        }
        const fstData = this.getDomainData(this.props.finTypesDomain, this.props.domain);
        if (fstData !== undefined && fstData.isRequesting === false && fstData.requestResult === null)
            this.props.ensureDomainData(this.props.finTypesDomain, { types });
    }

    getDomainData = (path, domain) => {
        return path.indexOf('.') === -1 ? domain[path] : getNested(domain, path);
    }

    componentDidUpdate() {
        const selectedTypes = this.getSelectionData(this.props.finTypesDomain);
        const fstData = this.getDomainData(this.props.finTypesDomain, this.props.domain);

        if (fstData.requestResult !== null && !this.state.initialized) {
            let reselected = [];
            this.getSelected(reselected, fstData.requestResult, selectedTypes.map(i => i.value));
            this.props.selection[this.props.typesName].all = reselected.slice(0);
            this.setState({ initialized: true });
        }

        if (selectedTypes.length > 0 && !this.state.hasData) {
            this.setState({ hasData: true });
        } else if (selectedTypes.length === 0 && this.state.hasData) {
            this.setState({ hasData: false });
        }
    }

    render() {
        if (this.props.asLink) {
            return <span onClick={this.onButtonClick}>{this.props.linkText}</span>;
        }

        const st = this.props.selection[this.props.rowsName].all.map(x => x.label).join(';');
        return (
            <div className={classnames({ 'horizontal': this.props.horizontal })}>
                {this.props.placeholder && <label>{this.props.placeholder}</label>}
                <div className={classnames({ "control": true, 'has-data': this.state.hasData })}>
                    <div className='input' onClick={this.onButtonClick} style={{ cursor: 'pointer', height: "2.5em" }} title={st.replace(/<sup>/g, ' (').replace(/<\/sup>/g, ')')}>
                        {this.renderInputContent()}
                    </div>
                </div>
                {!this.isInitialized && this.renderLoading()}
            </div>
        )

    }
    get isInitialized(){
        const fstData = this.getDomainData(this.props.finTypesDomain, this.props.domain);
        return fstData.requestResult !== null && this.state.initialized;
    }
    renderInputContent = () => {
        return (
            <div className="multi-select-inner">
                <div >{this.props.selection[this.props.rowsName].all.length}&nbsp;{this.props.translate("Common.SelectedItems")}</div>
                <div className="link-internal"><UpravitIcon fill="#ff8800" style={{ width: "25px", height: "25px" }} />{this.props.translate("Common.Button.Update")}</div>
            </div>
        )
    }
    renderLoading = () => {
        return <div style={{ width: '100%', height: 2 }}><div className="search-progress searching" style={{ height: 2 }}></div></div>;
    }

    getSelected = (result, root, ids) => {
        for (let index = 0; index < root.length; index++) {
            if (ids.slice(0).includes(root[index].value)) {
                result.push(root[index]);
            }
            if (root[index].children !== null && root[index].children !== undefined && root[index].children.length > 0) {
                this.getSelected(result, root[index].children, ids);
            }
        }
    }
    onButtonClick = () => {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick();
        };
        this.props.showPopup('finStatementsMultiSelect', {
            open: true,
            finStatementTypesOk: () => {
                if (isFunction(this.props.onClosed)) {
                    this.props.onClosed(this.props.selection);
                }
            },
            finStatementRowsOk: () => {
                this.props.hidePopup();
                if (isFunction(this.props.onClosed)) {
                    this.props.onClosed(this.props.selection);
                }
            },
            close: () => { this.props.hidePopup(); },
            getUpdatedSelection: () => { return this.props.selection },
            isInPopup: true,
            finStatementTypes: this.props.finTypesDomain,
            finStatementRows: FIN_STATEMENT_ROWS,
            selection: this.props.selection,
            typesName: this.props.typesName,
            rowsName: this.props.rowsName,
            finStatementTypesChanged: this.finStatementTypesChanged,
            finStatementRowsChanged: this.finStatementRowsChanged,
            onScroll: this.props.onScroll
        });
    }

    finStatementTypesChanged = (allSelectedNodes, parentSelectedNodes) => {
        if (typeof this.props.finStatementTypesChanged === 'function') {
            this.props.finStatementTypesChanged(allSelectedNodes, parentSelectedNodes);
        }
    }

    finStatementRowsChanged = (allSelectedNodes, parentSelectedNodes) => {
        if (typeof this.props.finStatementRowsChanged === 'function') {
            this.props.finStatementRowsChanged(allSelectedNodes, parentSelectedNodes);
        }
    }

    getSelectionData = (type) => {
        if (type === this.props.finTypesDomain) {
            try {
                return this.props.selection[this.props.typesName].all.slice(0);
            } catch {
                return [];
            }
        } else if (type === FIN_STATEMENT_ROWS) {
            try {
                return this.props.selection[this.props.rowsName].all.slice(0);
            } catch {
                return [];
            }
        } else
            return [];
    }
}

export default withLocalize(connect(
    state => ({ popup: state.popup, domain: state.domain }),
    dispatch => bindActionCreators(({ ...popupActions, ...domainActions }), dispatch)
)(FinStatementsMultiSelectPopupButton));